import React from 'react';
import { Search, Menu, Smartphone, Monitor } from 'lucide-react';

const Topbar = ({ user, searchQuery, setSearchQuery, onOpenMenu, orientationFilter, setOrientationFilter, activeView }) => {
  
  const handleOrientationChange = (newOrientation) => {
    console.log('🔄 Mudando orientação para:', newOrientation);
    if (typeof setOrientationFilter === 'function') {
      setOrientationFilter(newOrientation);
    } else {
      console.error('❌ setOrientationFilter não é uma função!', setOrientationFilter);
    }
  };
  
  return (
    <header className="sticky top-0 z-40 bg-[#05050A]/90 backdrop-blur-xl border-b border-white/5 font-sans">
      <div className="flex flex-col gap-4 px-4 md:px-6 py-4">
        
        <div className="flex items-center justify-between gap-4">
          {/* Mobile Menu Trigger */}
          <button 
            onClick={onOpenMenu}
            className="p-2 -ml-2 text-slate-400 hover:text-white md:hidden transition-colors"
          >
            <Menu className="w-6 h-6" />
          </button>

          {/* Search Section */}
          <div className="flex items-center gap-4 flex-1 max-w-2xl">
            <div className="relative flex-1">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
              <input
                type="text"
                placeholder="Buscar cenas..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full bg-[#0A0A12] border border-white/10 rounded-xl pl-11 pr-4 py-3 text-sm text-white placeholder-slate-600 focus:outline-none focus:border-[#0056D2]/50 focus:ring-2 focus:ring-[#0056D2]/20 transition-all duration-300 font-medium"
              />
            </div>
          </div>

          {/* Info Section */}
          <div className="flex items-center gap-3 md:gap-6">
            {/* User Info */}
            <div className="flex items-center gap-3">
              <div className="text-right hidden sm:block">
                <span className="text-slate-500 text-[10px] uppercase font-bold tracking-tighter">Bem-vindo,</span>
                <p className="text-white text-sm font-bold italic uppercase tracking-tight">
                  {user?.name?.split(' ')[0] || user?.email?.split('@')[0] || 'Editor'}
                </p>
              </div>
              <div className="w-10 h-10 bg-gradient-to-br from-[#0056D2] to-[#0042A1] rounded-full flex items-center justify-center text-white font-bold shadow-lg shadow-[#0056D2]/20 border border-white/10">
                {user?.email?.[0]?.toUpperCase() || 'E'}
              </div>
            </div>
          </div>
        </div>

        {/* Orientation Filter Tabs - só aparece em home e coleções, NÃO em referências */}
        {activeView !== 'references' && (
          <div className="flex items-center gap-2 pb-2">
            <button
              onClick={() => handleOrientationChange('vertical')}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-bold transition-all ${
                orientationFilter === 'vertical'
                  ? 'bg-[#0056D2] text-white'
                  : 'bg-white/5 text-slate-400 hover:text-white hover:bg-white/10'
              }`}
            >
              <Smartphone size={16} />
              Vertical (9:16)
            </button>
            <button
              onClick={() => handleOrientationChange('horizontal')}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-bold transition-all ${
                orientationFilter === 'horizontal'
                  ? 'bg-[#0056D2] text-white'
                  : 'bg-white/5 text-slate-400 hover:text-white hover:bg-white/10'
              }`}
            >
              <Monitor size={16} />
              Horizontal (16:9)
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Topbar;
